import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    current: {},
    currentLoading: false,
    permissions: [],
    permissionsLoading: false,
    permissionCurrent: {},
    permissionCurrentLoading: false
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setPermissionsLoading(state, payload) {
      state.permissionsLoading = payload;
    },
    setPermissions(state, payload) {
      state.permissions = payload;
    },
    setPermissionCurrentLoading(state, payload) {
      state.permissionCurrentLoading = payload;
    },
    setPermissionCurrent(state, payload) {
      state.permissionCurrent = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("users");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setCurrentLoading", true);
      let response = await api.get("users/byID", { params: { id: id } });
      commit("setCurrent", response.data[0]);
      commit("setCurrentLoading", false);
    },
    async loadPermissionsForUser({ commit }, id) {
      commit("setPermissionsLoading", true);
      let response = await api.get("users/permissionsForUser", {
        params: { id: id }
      });
      commit("setPermissions", response.data);
      commit("setPermissionsLoading", false);
    },
    async loadPermissionByID({ commit }, id) {
      commit("setPermissionCurrentLoading", true);
      let response = await api.get("users/permissionsByID", {
        params: { id: id }
      });
      commit("setPermissionCurrent", response.data[0]);
      commit("setPermissionCurrentLoading", false);
    },
    async newUser({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("users", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async saveUser({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`users`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async deleteUser({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("users/delete", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async resetUserTempPassword({ dispatch }, payload) {
      api.post(`users/resetTempPassword`, payload);
    },
    async resendInviteEmail({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`users/resendInviteEmail`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async userEmailChangeRequest({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`user/emailChangeRequest`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success"
            };
          } else {
            returnData = {
              Result: "Failed"
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadCurrentUserData");
      return returnData;
    },
    async userEmailVerification({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`user/verifyUserEmail`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success"
            };
          } else {
            returnData = {
              Result: "Failed"
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadCurrentUserData");

      return returnData;
    },
    async resetPasswordChangeRequest({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`user/passwordChangeRequest`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async userPermissionsNew({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`users/newUserPermission`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadPermissionsForUser", payload.users_id);
      return returnData;
    },
    async userPermissionsSave({ dispatch }, payload) {
      let returnData = {};

      await api
        .put(`users/saveUserPermission`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success"
            };
          } else {
            returnData = {
              Result: "Failed"
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadPermissionsForUser", payload.users_id);
      return returnData;
    },
    async userRemovePermission({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`users/removeUserPermission`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });

      return returnData;
    },
    async devChangeClubAdminAssociation({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`dev/changeTestClubAdminAssociation`, {
          associations_id: payload
        })
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });

      return returnData;
    },

    // Uploading Profile Image
    async changeProfileImage({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`user/changeProfileImage`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });

      dispatch("auth/loadCurrentUserData", null, { root: true });

      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    permissions(state) {
      return state.permissions;
    },
    permissionsLoading(state) {
      return state.permissionsLoading;
    },
    permissionCurrent(state) {
      return state.permissionCurrent;
    },
    permissionCurrentLoading(state) {
      return state.permissionCurrentLoading;
    }
  }
};
